import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth-service/auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StylingService {
  theme: Theme = Theme.webBrightTheme;
  editMode: boolean = false;
  colorArr = ["#294f94", "#ffffff"];
  addon = {
    countdown: true
  }
  appMenu = {
    events: true,
    results: true,
    schedule: true,
    lineup: true,
    news: true,
    products: true,
    home: true,
    gallery: true,
    contact: true,
    sessions:true,
    website:true,

  };
  menuCode: string = "ernhgc";

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    ) {
    this.setStyling();
    console.log('theme: Theme', this.theme)
  }

  setStyling() {
    let bodyQuerySelectror = document.querySelectorAll('body');
    switch (this.theme) {
      case Theme.webBrightTheme: {
        document.documentElement.style.setProperty('--bodyBg', "white");
        document.documentElement.style.setProperty('--fontColor', "black");
        bodyQuerySelectror.forEach((body)=>{
          body.classList.remove('desktopDarkTheme')
        })
        break;
      }
      case Theme.webDarkTheme: {
        document.documentElement.style.setProperty('--bodyBg', "black");
        document.documentElement.style.setProperty('--fontColor', "white");
        bodyQuerySelectror.forEach((body)=>{
          body.classList.remove('desktopDarkTheme')
        })
        break;
      }
      case Theme.desktopBrightTheme: {
        document.documentElement.style.setProperty('--bodyBg', "#f5f7fb");
        document.documentElement.style.setProperty('--fontColor', "black");
        document.documentElement.style.setProperty('--mainColor', "#0ec6c6");
        document.documentElement.style.setProperty('--main-color', "#30eded");
        bodyQuerySelectror.forEach((body)=>{
          body.classList.remove('desktopDarkTheme')
        })
        break;
      }
      case Theme.desktopDarkTheme: {
        document.documentElement.style.setProperty('--bodyBg', "#202938");
        document.documentElement.style.setProperty('--fontColor', "white");
        bodyQuerySelectror.forEach((body)=>{
          body.classList.add('desktopDarkTheme')
        })
        break;
      }
    }

    document.documentElement.style.setProperty('--firstvalue', "#294f94");
    document.documentElement.style.setProperty('--secondvalue', "#ffffff");
  }

  setWebTheme(style: any) {
    console.log('style: ', style);
    if (typeof style === "undefined" || !style) return;

    localStorage.setItem("style-global", style);

    this.theme = Number(style.split('-')[0]);
    // this.setDefaultColors();

    if (style.split('-').length > 1) {
      let color1 = "#" + style.split('-')[1];
      let color2 = "#" + style.split('-')[2];

      this.colorArr[0] = color1;
      this.colorArr[1] = color2;
      
      //vesax
      document.documentElement.style.setProperty('--mainColor', color1);
      document.documentElement.style.setProperty('--main-color', color1);
      document.documentElement.style.setProperty('--mainColor1', color1);

      //placid
      document.documentElement.style.setProperty('--main-color', color1);
      document.documentElement.style.setProperty('--blackColor', color1);

      if (!color2.includes("#ffffff")) {
        document.documentElement.style.setProperty('--mainColor2', color2);
        document.documentElement.style.setProperty('--white-color', color2);
      }
    }

    if (style.split('-').length > 3) {
      this.appMenu.events = style.split('-')[3].includes('e') ? true : false;
      this.appMenu.results = style.split('-')[3].includes('r') ? true : false;
      this.appMenu.schedule = style.split('-')[3].includes('s') ? true : false;
      this.appMenu.lineup = style.split('-')[3].includes('l') ? true : false;
      this.appMenu.products =  style.split('-')[3].includes('p') ? true : false;
      this.appMenu.news = style.split('-')[3].includes('n') ? true : false;
      this.appMenu.gallery = style.split('-')[3].includes('g') ? true : false;
      this.appMenu.contact = style.split('-')[3].includes('c') ? true : false;
      this.appMenu.sessions = style.split('-')[3].includes('ss') ? true : false;
      this.appMenu.website = style.split('-')[3].includes('ws') ? true : false;

      this.setMenuCode();
    }

    let parts = style.split('-&');
    if (style.includes('token')) {
      let token = this.getTokenFromParts("token", parts);
      console.log('token', token)
      localStorage.setItem('token', token);
    }

    if(style.includes("edit")){
      this.editMode = !!+this.getValueByKey("edit", parts);
      localStorage.setItem('edit', this.editMode + "");
    }

    let lid = this.getValueByKey("lid", parts, "214601");
    this.authService.lid = Number(lid);
    localStorage.setItem('lid', lid);

    if (style.includes("lang")) {
      const lang = this.getValueByKey("lang", parts);
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
    }

    if (style.includes("redirect")) {
      const path = this.getValueByKey("redirect", parts);
      this.router.navigate([path]);
    }
  }

  getValueByKey(key: string, arr: any, defaultValue: any = ""){
    let value = defaultValue;
    for(let i = 0; i < arr.length; i++){
      if(arr[i].includes(key)){
        value = arr[i].split("-")[1];
        return value;
      }
    }
    return value;
  }
  getTokenFromParts(key: string, arr: string[]): string {
    for (let part of arr) {
      if (part.startsWith(`${key}-`)) {
        let newPart = part.split(`${key}-`)
        return newPart[1];
        // return part.substring(key.length + 2);
      }
    }
    return "";
  }

  setMenuCode() {
    let res = "";
    for (let property in this.appMenu) {
      if ((this.appMenu as any)[property]) res += property[0];
    }
    this.menuCode = res;
  }

  setDefaultColors() {
    switch (Number(this.theme)) {
      case Theme.webBrightTheme: {
        document.documentElement.style.setProperty('--mainColor', "#0ec6c6");
        document.documentElement.style.setProperty('--mainColor2', "#30eded");
        document.documentElement.style.setProperty('--bodyBg', "white");
        document.documentElement.style.setProperty('--fontColor', "black");
        document.documentElement.style.setProperty('--white-color', "white");
        break;
      }
      case Theme.webDarkTheme: {
        document.documentElement.style.setProperty('--mainColor', "#c9ab81");
        document.documentElement.style.setProperty('--main-color', "#c9ab81");
        document.documentElement.style.setProperty('--white-color', "#ffffff");
        document.documentElement.style.setProperty('--bodyBg', "black");
        document.documentElement.style.setProperty('--fontColor', "white");
        break;
      }
      case Theme.desktopBrightTheme: {
        document.documentElement.style.setProperty('--mainColor', "#0ec6c6");
        document.documentElement.style.setProperty('--main-color', "#30eded");
        document.documentElement.style.setProperty('--white-color', "#ffffff");
        document.documentElement.style.setProperty('--bodyBg', "#f5f7fb");
        document.documentElement.style.setProperty('--fontColor', "black");
        break;
      }
      case Theme.desktopDarkTheme: {
        document.documentElement.style.setProperty('--mainColor', "#0ec6c6");
        document.documentElement.style.setProperty('--main-color', "#30eded");
        document.documentElement.style.setProperty('--white-color', "#ffffff");
        document.documentElement.style.setProperty('--bodyBg', "#202938");
        document.documentElement.style.setProperty('--fontColor', "white");
        break;
      }
    }
  }


}

export enum Theme {
  webBrightTheme,
  webDarkTheme,
  appClassicTheme,
  appModernTheme,
  appDarkTheme,
  desktopBrightTheme,
  desktopDarkTheme
}
